export const GET_REQUESTS = 'GET_REQUESTS'
export const REMOVE_RECEIVED_REQUEST = 'REMOVE_RECEIVED_REQUEST'
